import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared';
import { CSVFileExporterService, ExcelFileExporterService, FileExporterService, FileWriterService } from './services';
import { FileExporterChoicePopupComponent, PdfConfigurationPage } from './components';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FileExporterChoicePopupComponent, PdfConfigurationPage],
  imports: [CommonModule, IonicModule, SharedModule,FormsModule],
  exports: [FileExporterChoicePopupComponent],
  providers: [ExcelFileExporterService, CSVFileExporterService, FileExporterService, FileWriterService]
})
export class FileExporterModule {}
